<assessment-row title="Urine Color">
  <p>{{ data.urineColor }}</p>
</assessment-row>

<assessment-row title="Urine Characteristics">
  <emr-list [list]="data.urineCharacteristics" emptyText="N/A"></emr-list>
</assessment-row>

<assessment-row title="Urinary Pattern">
  <emr-list [list]="data.urinaryPattern" emptyText="N/A"></emr-list>
</assessment-row>

<h2>Foley</h2>

<assessment-row title="Justification">
  <p>{{ data.foleyJustification }}</p>
</assessment-row>

<assessment-row title="Securement">
  <p>{{ data.foleySecurement }}</p>
</assessment-row>

@if (patient().isObstetric()) {
@if (data.hasAbnormalLochia) {
<h2>Abnormal Lochia</h2>
<assessment-row title="Inappropriate Color?">
  <p>{{ data.abnormalLochiaHasInappropriateColor | booleanToYesNo }} </p>
</assessment-row>

<assessment-row title="Heavy Bleeding?">
  <p>{{ data.abnormalLochiaHasHeavyBleeding | booleanToYesNo }}</p>
</assessment-row>

<assessment-row title="Foul Odor?">
  <p>{{ data.abnormalLochiaHasFoulOdor | booleanToYesNo }} </p>
</assessment-row>

<assessment-row title="Other">
  <p>{{ data.abnormalLochiaOther }}</p>
</assessment-row>
}
}

@if (data.hasAbnormalUterine) {

<h2>Abnormal Uterine Assessment</h2>
<assessment-row title="Fundal Locaton">
  <p>{{ data.abnormalUterineFundalLocation }}</p>
</assessment-row>
<assessment-row title="Fundal Feel">
  <p>{{ data.abnormalUterineFundalFeel }}</p>
</assessment-row>

@if (data.areContractionsPresent) {
<h3>Contractions</h3>
<assessment-row title="Contraction Strength">
  <p>{{ data.contractionsStrength }}</p>
</assessment-row>
<assessment-row title="Contraction Duration">
  <p>{{ data.contractionsDuration }}</p>
</assessment-row>
<assessment-row title="Contraction Frequency">
  <p>{{ data.contractionsFrequency }}</p>
</assessment-row>
}

@if (data.hasFetalHeartTones) {
<h2>Fetal Heart Tones Present</h2>
<assessment-row title="Accelerations Noted">
  <p>{{ data.fetalHeartTonesAccelerationsNoted }}</p>
</assessment-row>
<assessment-row title="Decelerations Noted">
  <p>{{ data.fetalHeartTonesDecelerationsNoted }}</p>
</assessment-row>
<assessment-row title="FHT Variability">
  <p>{{ data.fetalHeartTonesVariability }}</p>
</assessment-row>
}

@if (data.hasAbnormalVaginalAssessment) {
<h2>Abnormal Vaginal Assessment</h2>
<assessment-row title="Episiotomy">
  <p>{{ data.abnormalVaginalEpisiotomy }}</p>
</assessment-row>
<assessment-row title="Tear">
  <p>{{ data.abnormalVaginalTear }}</p>
</assessment-row>
<assessment-row title="Dilation">
  <p>{{ data.abnormalVaginalDilation }}</p>
</assessment-row>
<assessment-row title="Station">
  <p>{{ data.abnormalVaginalStation }}</p>
</assessment-row>
}

}